import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Card from '../Card/Card'
import Text from '../Text/Text'
import Filter from '../Filter/Filter'
import NotificationsList from '../NotificationsList/NotificationsList'
import BellButton from '../BellButton/BellButton'
import ClickOutside from '../ClickOutside/ClickOutside'

import EmptyNotifications from './EmptyNotifications'
import NotificationsListSkeleton from './NotificationsListSkeleton'

import { getPanelCurrentPositions } from '../../lib/utils'

import styles from './notificationPanel.scss'

import colors from '../../styles/theme/colors.scss'

const DEFAULT_PANEL_WIDTH = 420

export const getPanelContentClassNames = (
  bell,
  panel,
  stylesConfig = styles
) => {
  const panelPositions = getPanelCurrentPositions(bell, panel)
  const defaultArrowClasses = classNames(
    stylesConfig.content,
    stylesConfig.arrowRight
  )

  const { canRenderLeft, canRenderRight } = panelPositions

  let contentClassNames = defaultArrowClasses

  if (!canRenderLeft) {
    contentClassNames = classNames(stylesConfig.content, stylesConfig.arrowLeft)

    if (!canRenderRight) contentClassNames = defaultArrowClasses
  }

  return contentClassNames
}

class NotificationPanel extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false
    }

    this.handleDropdown = this.handleDropdown.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.listRef = React.createRef()
    this.panelRef = React.createRef()
    this.bellRef = React.createRef()
  }

  handleDropdown() {
    const { onClickBell } = this.props

    const { open } = this.state

    this.setState({
      open: !open
    })

    if (onClickBell && !open) onClickBell()
  }

  handleClickOutside() {
    this.setState({
      open: false
    })
  }

  render() {
    const {
      products,
      notifications,
      isLoading,
      isSkeletonVisible,
      totalUnread,
      bellButtonIcon,
      onHandleFilterOptions,
      labelFilterProducts,
      handleScroll,
      hasError,
      onClickAction,
      isPaginationFinished,
      removeNegotiationById
    } = this.props

    const { open } = this.state

    const panelClass = classNames(styles.panel, {
      [styles.open]: open
    })

    const hasProducts = products.length > 0
    const hasNotifications = notifications.length > 0

    const notificationsList = hasNotifications ? (
      <NotificationsList
        notifications={notifications}
        products={products}
        onClickAction={onClickAction}
        isLoading={isLoading}
        isPaginationFinished={isPaginationFinished}
        removeNegotiationById={removeNegotiationById}
      />
    ) : (
      <EmptyNotifications hasError={hasError} />
    )

    const { current: bell } = this.bellRef
    const { current: panel } = this.panelRef

    const panelPositions = getPanelCurrentPositions(bell, panel)
    const contentClassNames = getPanelContentClassNames(bell, panel)

    const panelWidth =
      panelPositions.viewportWidth < DEFAULT_PANEL_WIDTH
        ? '90%'
        : `${DEFAULT_PANEL_WIDTH}px`

    const panelStyle = {
      position: 'absolute',
      width: panelWidth,
      left: panelPositions,
      top: panelPositions.y
    }

    return (
      <div className={panelClass}>
        <ClickOutside onClickOutside={this.handleClickOutside}>
          <BellButton
            counter={totalUnread}
            onClick={this.handleDropdown}
            icon={bellButtonIcon}
            reference={this.bellRef}
          />

          <div
            id="scrollWrapper"
            className={contentClassNames}
            onScroll={
              (event) =>
                handleScroll && handleScroll(event, this.listRef.current) // eslint-disable-line
            }
            ref={this.panelRef}
            //  style={panelStyle}
          >
            <Card>
              <div>
                <div className={styles.header}>
                  <Text
                    label="Notificações"
                    labelFontSize="16px"
                    strong
                    labelLineHeight="24px"
                    color={colors.primaryTextColor}
                    title
                  />
                  {hasProducts && (
                    <div className={styles.filter}>
                      <Filter
                        label={labelFilterProducts}
                        products={products}
                        onHandleOptions={onHandleFilterOptions}
                      />
                    </div>
                  )}
                </div>
                <div ref={this.listRef}>
                  {isSkeletonVisible ? (
                    <NotificationsListSkeleton />
                  ) : (
                    notificationsList
                  )}
                </div>
              </div>
            </Card>
          </div>
        </ClickOutside>
      </div>
    )
  }
}

NotificationPanel.defaultProps = {
  products: [],
  notifications: [],
  totalUnread: null,
  isLoading: false,
  isSkeletonVisible: false,
  isPaginationFinished: false,
  onClickBell: null,
  onHandleFilterOptions: null,
  labelFilterProducts: null,
  bellButtonIcon: null,
  handleScroll: null,
  hasError: false,
  onClickAction: null,
  removeNegotiationById: null
}

NotificationPanel.propTypes = {
  onClickAction: PropTypes.func,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      icon: PropTypes.string
    })
  ),
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      title: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
      readAt: PropTypes.string,
      actions: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
          title: PropTypes.string,
          url: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        })
      )
    })
  ),
  totalUnread: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  isSkeletonVisible: PropTypes.bool,
  onClickBell: PropTypes.func,
  bellButtonIcon: PropTypes.string,
  onHandleFilterOptions: PropTypes.func,
  labelFilterProducts: PropTypes.string,
  handleScroll: PropTypes.func,
  hasError: PropTypes.bool,
  isPaginationFinished: PropTypes.bool,
  removeNegotiationById: PropTypes.func
}

export default NotificationPanel
